import { LearnerPlanListPage } from "@/features/learner/components/LearnerPlanList";

const LearnerPlanList = () => {
  return <LearnerPlanListPage />;
};

export default LearnerPlanList;
